import React from 'react';
import { BookOpen, Search, ShoppingCart, Clock, Utensils, FileText, ArrowRight } from 'lucide-react';
export function BenefitsSection() {
  const items = [{
    icon: Search,
    title: 'El Test del Espejo',
    desc: '3 observaciones simples (no diagnóstico)'
  }, {
    icon: BookOpen,
    title: 'Diccionario de Azúcares Ocultos',
    desc: 'Los nombres del azúcar en etiquetas'
  }, {
    icon: ShoppingCart,
    title: 'Chequeo del "Pasillo Saludable"',
    desc: 'Cómo comprar con más criterio en EE. UU.'
  }, {
    icon: Utensils,
    title: 'Método del Orden del Plato',
    desc: 'Reduce picos cambiando el orden de la comida'
  }, {
    icon: FileText,
    title: 'Plan de 14 Días',
    desc: 'Checklist + registro'
  }, {
    icon: Clock,
    title: 'Protocolo de Rescate de 15 Minutos',
    desc: 'Qué hacer tras una comida alta en carbohidratos'
  }];
  return <section className="py-24 px-4 bg-[#0f0f0f]" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-serif text-center text-white mb-16" data-id="element-3">
          Lo que obtendrás dentro de El Azúcar Silencioso
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-4">
          {items.map((item, idx) => <div key={idx} className="bg-[#1a1a1a] p-8 rounded-xl border border-[#2a2a2a] hover:border-[#C9A84C]/50 transition-colors duration-300 group" data-id="element-5">
              <div className="w-12 h-12 bg-[#0f0f0f] rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#C9A84C]/10 transition-colors" data-id="element-6">
                <item.icon className="w-6 h-6 text-[#C9A84C]" data-id="element-7" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-[#888] leading-relaxed" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-10">
          <button onClick={() => document.getElementById('price-box')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group bg-[#C9A84C] hover:bg-[#b09240] text-black font-semibold text-lg py-4 px-10 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] flex items-center justify-center gap-2 mx-auto" data-id="element-11">
            <span data-id="element-12">Sí, quiero empezar a leer</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-13" />
          </button>
        </div>
      </div>
    </section>;
}